var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from 'react';
import Icons from './Icons/Icons';
import { formatPrice } from '../utils/utilities';
import cartUtil from '../utils/cartUtil';
import Recommendations from './recommendations';
import ComplimentarySamples from './ComplimentarySamples/ComplimentarySamplesNew';
import Banner from './ComplimentarySamples/Banner';
import samplesUtil from '../utils/samplesUtil';
const CartItem = (_a) => {
    var { item, updateCartItems, items, setSecondaryLoading, isSecondaryLoading, setCartItemsLoading } = _a, props = __rest(_a, ["item", "updateCartItems", "items", "setSecondaryLoading", "isSecondaryLoading", "setCartItemsLoading"]);
    const [isLoading, setIsLoading] = useState(false);
    const [includedWithProductKey, setIncludedWithProductKey] = useState(null);
    const [includedWithProductTitle, setIncludedWithProductTitle] = useState(null);
    const [attachedComplimentaryKey, setAttachedComplimentaryKey] = useState(null);
    const isComplimentary = item.properties._complimentary;
    useEffect(() => {
        if (isComplimentary) {
            let foundIncludedWithProduct = items.find(i => i.id == item.properties._complimentary);
            setIncludedWithProductKey((foundIncludedWithProduct || {}).key);
            setIncludedWithProductTitle((foundIncludedWithProduct || {}).product_title);
        }
        else {
            let foundAttachedComplimentary = items.find(i => i.properties._complimentary == item.variant_id);
            setAttachedComplimentaryKey((foundAttachedComplimentary || {}).key);
        }
    }, [items, isComplimentary]);
    const handleRemoveItem = (item) => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        setCartItemsLoading(true);
        let itemsToUpdate = [item];
        if (attachedComplimentaryKey) {
            setSecondaryLoading(attachedComplimentaryKey);
            let attachedComplimentary = items.find(i => i.key == attachedComplimentaryKey);
            itemsToUpdate.push(attachedComplimentary);
        }
        yield updateCartItems(itemsToUpdate, 0);
        setIsLoading(false);
        setSecondaryLoading(null);
        setCartItemsLoading(false);
    });
    const handleUpdateQuantity = (item, quantity) => __awaiter(void 0, void 0, void 0, function* () {
        if (includedWithProductKey) {
            let includedWithProduct = items.find(i => i.key == includedWithProductKey);
            let includedQuantity = includedWithProduct.quantity;
            if (quantity > includedQuantity) {
                quantity = includedQuantity;
                return;
            }
        }
        setIsLoading(true);
        setCartItemsLoading(true);
        let itemsToUpdate = [item];
        if (attachedComplimentaryKey) {
            let attachedComplimentary = items.find(i => i.key == attachedComplimentaryKey);
            if (quantity < attachedComplimentary.quantity) {
                setSecondaryLoading(attachedComplimentary.key);
                itemsToUpdate.push(attachedComplimentary);
            }
        }
        yield updateCartItems(itemsToUpdate, quantity);
        setIsLoading(false);
        setSecondaryLoading(null);
        setCartItemsLoading(false);
    });
    const priceDisplay = (item) => {
        if (!!item.discounted_line_price && item.discounted_line_price < item.original_line_price) {
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "sidecart-item__cost--original" }, formatPrice(item.original_line_price)),
                React.createElement("span", { className: "sidecart-item__cost--current" }, formatPrice(item.discounted_line_price))));
        }
        if (parseFloat(item.compare_at_price) > item.price) {
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "sidecart-item__cost--original" }, formatPrice(item.compare_at_price * item.quantity)),
                React.createElement("span", { className: "sidecart-item__cost--current" }, formatPrice(item.price * item.quantity))));
        }
        return (React.createElement("span", null, formatPrice(item.price * item.quantity)));
    };
    return (React.createElement("div", Object.assign({ className: "sidecart-item" }, props),
        React.createElement("div", { className: `sidecart-item__loader ${isLoading || (isSecondaryLoading === item.key) ? 'sidecart-item__loader--active' : ''}` },
            React.createElement("div", { className: "sidecart-item__loader-spinner" },
                React.createElement(Icons.Loading, null))),
        React.createElement("div", { className: "sidecart-item__image" },
            React.createElement("img", { src: item.featured_image.url, alt: item.featured_image.alt })),
        React.createElement("div", { className: "sidecart-item__details" },
            React.createElement("div", { className: "sidecart-item__details-info" },
                React.createElement("a", { href: item.product_url, className: "sidecart-item__details-info__title" }, item.product_title),
                !item.product_has_only_default_variant && (React.createElement("span", { className: "sidecart-item__details-info__options" }, item.variant_options)),
                includedWithProductTitle && (React.createElement("span", { className: "sidecart-item__details-info__included" },
                    "Included with ",
                    includedWithProductTitle))),
            React.createElement("div", { className: "sidecart-item__details-quantity" },
                React.createElement("button", { className: 'sidecart-item__quantity-button', onClick: () => handleUpdateQuantity(item, item.quantity - 1) },
                    React.createElement(Icons.Minus, null)),
                React.createElement("span", { className: 'sidecart-item__quantity-amount' }, item.quantity),
                React.createElement("button", { className: 'sidecart-item__quantity-button', onClick: () => handleUpdateQuantity(item, item.quantity + 1) },
                    React.createElement(Icons.Plus, null)),
                React.createElement("button", { className: 'sidecart-item__remove', onClick: () => handleRemoveItem(item) }, "Remove"))),
        React.createElement("div", { className: "sidecart-item__cost" }, priceDisplay(item))));
};
const SideCart = (props) => {
    const [cart, setCart] = useState(null);
    const [cartOpen, setCartOpen] = useState(false);
    const [secondaryLoading, setSecondaryLoading] = useState(null);
    const [cartItemsLoading, setCartItemsLoading] = useState(false);
    const [samples, setSamples] = useState([]);
    const [loadingSamples, setLoadingSamples] = useState(false);
    const [checkoutDisabled, setCheckoutDisabled] = useState(false);
    const [selectedOption, setSelectedOption] = useState({ tag: '', title: '' });
    const footerRef = useRef(null);
    const bundleDataRef = useRef(null);
    const scrollPositionRef = useRef(0);
    let { item_count: itemCount, total_price: totalPrice, items } = cart || {};
    const { upsellTitle, upsellDescription } = props;
    let cartData = Object.assign(Object.assign({}, cart), { total_price: parseFloat((bundleDataRef.current || {}).total_amount_discounted) || parseFloat((cart || {}).total_price), original_total_price: parseFloat((bundleDataRef.current || {}).total_amount_original) || parseFloat((cart || {}).total_price) });
    if (bundleDataRef.current) {
        cartData.items = ((cartData || {}).items || []).map((item) => {
            let bundleDataItem = bundleDataRef.current.discounted_cart_object.items.find((bundleItem) => bundleItem.key == item.key);
            item.original_line_price = (bundleDataItem || {}).original_line_price || item.compare_at_price;
            item.discounted_line_price = (bundleDataItem || {}).line_price;
            return item;
        });
    }
    let cartItems = (cartData || {}).items || items;
    useEffect(() => {
        let cartButton = document.querySelector(".header__cart");
        window.addEventListener("cart-updated", updateCartEvent.bind(this));
        window.addEventListener("cart-added-item", addCartEvent.bind(this));
        cartButton.addEventListener("click", toggleCart);
        document.addEventListener('bundler:total_cart_values', initializeBundleDiscount.bind(this));
        initializeCart();
        return () => {
            window.removeEventListener("cart-updated", updateCartEvent.bind(this));
            window.removeEventListener("cart-added-item", addCartEvent.bind(this));
            document.removeEventListener('bundler:total_cart_values', initializeBundleDiscount.bind(this));
            cartButton.removeEventListener("click", toggleCart);
        };
    }, []);
    // Handle sample validation when cart items or samples change
    useEffect(() => {
        const validateSamples = () => __awaiter(void 0, void 0, void 0, function* () {
            if (cartItems && cartItems.length >= 0 && samples.length > 0) {
                setCheckoutDisabled(true);
                yield samplesUtil.debouncedValidateSamplesInCartNew(cartItems, samples);
                setCheckoutDisabled(false);
            }
        });
        validateSamples();
    }, [cartItems, samples]);
    const getElementHeight = (element) => {
        return element ? (element.getBoundingClientRect() || {}).height : 0;
    };
    const initializeCart = (bundleData = false) => __awaiter(void 0, void 0, void 0, function* () {
        let newCart = yield (yield fetch("/cart?view=json-data")).json();
        newCart = Object.assign(Object.assign(Object.assign({}, cart), newCart), { original_total_price: parseFloat(newCart.total_price) });
        if (bundleData) {
            bundleDataRef.current = bundleData;
        }
        setCart(newCart);
    });
    const initializeBundleDiscount = (e) => __awaiter(void 0, void 0, void 0, function* () {
        let bundleData = e.detail;
        let discountedTotal = bundleData.total_amount_discounted;
        let originalTotal = bundleData.total_amount_original;
        if (bundleDataRef.current && bundleDataRef.current.total_amount_discounted == discountedTotal && bundleDataRef.current.total_amount_original == originalTotal) {
            return;
        }
        yield initializeCart(bundleData);
    });
    const toggleCart = (e = false) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (!cartOpen) {
            // Save current scroll position before opening cart
            scrollPositionRef.current = window.scrollY || window.pageYOffset;
            document.body.classList.add('locked');
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollPositionRef.current}px`;
            document.body.style.width = '100%';
            setCartOpen(true);
        }
        else {
            // Check if we should reload before closing
            if (window.location.href.indexOf('/cart') > -1) {
                window.location.reload();
                return false;
            }
            // Restore scroll position when closing cart
            const scrollPos = scrollPositionRef.current;
            document.body.classList.remove('locked');
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            setCartOpen(false);
            // Use requestAnimationFrame to ensure styles are applied before scrolling
            requestAnimationFrame(() => {
                window.scrollTo(0, scrollPos);
            });
        }
        return false;
    };
    const addCartEvent = (event) => __awaiter(void 0, void 0, void 0, function* () {
        yield initializeCart();
        return;
        if (!cartOpen) {
            toggleCart(event);
        }
    });
    const updateCartEvent = (event) => __awaiter(void 0, void 0, void 0, function* () {
        yield initializeCart();
        console.log('Cart updated:', event.detail);
    });
    const updateCartItems = (items, quantity) => __awaiter(void 0, void 0, void 0, function* () {
        setCheckoutDisabled(true);
        let updates = items.reduce((acc, item) => {
            acc[item.id] = quantity;
            return acc;
        }, {});
        yield cartUtil.update(updates);
        initializeCart();
        setCheckoutDisabled(false);
    });
    const updateVariants = (variantIds, quantity) => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingSamples(true);
        setCheckoutDisabled(true);
        if (quantity == 0) {
            let updates = variantIds.reduce((acc, id) => {
                acc[id] = 0;
                return acc;
            }, {});
            yield fetch(`/cart/update.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    updates
                })
            });
            yield initializeCart();
            setLoadingSamples(false);
            setCheckoutDisabled(false);
            return cart;
        }
        let items = variantIds.map(id => ({ id, quantity }));
        yield fetch(`/cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items
            })
        }).then(res => res.json());
        yield initializeCart();
        setLoadingSamples(false);
        setCheckoutDisabled(false);
        return cart;
    });
    const goToCheckout = () => {
        if (itemCount == 0) {
            toggleCart();
            return;
        }
        window.location.href = '/checkout';
    };
    let filteredCartItems = (cartItems || []).filter(item => {
        let hideItem = item.product_type == 'Free Gift' || item.product_type == 'Active Sample' || item.product_type == 'sample';
        return !hideItem;
    });
    let originalTotalPrice = filteredCartItems.reduce((acc, item) => {
        let price = (item.compare_at_price || item.original_price || item.price);
        return acc + (parseFloat(price) * item.quantity);
    }, 0);
    let itemCountComplimentary = (cartItems || []).reduce((acc, item) => {
        if (item.product_type == 'eGift Card' || item.product_type == 'Gift Card') {
            return acc;
        }
        return acc + item.quantity;
    }, 0);
    return (React.createElement("div", { className: `sidecart ${cartOpen ? 'sidecart--open' : ''}` },
        React.createElement("div", { className: `sidecart-overlay ${cartOpen ? 'sidecart-overlay--active' : ''}`, onClick: toggleCart }),
        React.createElement("div", { className: "sidecart-content" },
            React.createElement("div", { className: "sidecart-content__inner", style: { paddingBottom: getElementHeight(footerRef.current) } },
                React.createElement("div", { className: "sidecart-header" },
                    React.createElement("h3", null,
                        "Cart (",
                        itemCount,
                        ")"),
                    React.createElement("div", { className: "sidecart-header__close", onClick: toggleCart, role: 'button', "aria-label": 'Close cart' },
                        React.createElement(Icons.Close, null))),
                React.createElement(Banner, { cartItems: cartItems || [], settings: props, loadingSamples: loadingSamples }),
                itemCount == 0
                    ? (React.createElement("div", { className: "sidecart-empty supports-cookies" },
                        React.createElement("h3", { className: "sidecart-empty__title" }, "You have no items in your cart."))) : (React.createElement("div", { className: 'sidecart-main' },
                    React.createElement("div", { className: "sidecart-items" }, (filteredCartItems || []).map((item, index) => React.createElement(CartItem, { key: item.key, item: item, updateCartItems: updateCartItems, items: cartItems, setSecondaryLoading: setSecondaryLoading, setCartItemsLoading: setCartItemsLoading, isSecondaryLoading: secondaryLoading === item.key }))),
                    React.createElement(Recommendations, { parentClass: '.sidecart', initializeCart: initializeCart, cartItems: cartItems, cartTotal: (cartItems || []).length, upsellTitle: upsellTitle, upsellDescription: upsellDescription }),
                    itemCountComplimentary > 0 && (React.createElement(ComplimentarySamples, { updateVariants: updateVariants, updateSamples: setSamples, cartItems: cartItems, loadingSamples: loadingSamples, settings: props }))))),
            React.createElement("div", { className: "sidecart-footer", ref: footerRef },
                React.createElement("div", { className: "sidecart-footer__shipping" }, "Complimentary Express Shipping within Australia"),
                React.createElement("div", { className: "sidecart-footer__subtotal" },
                    React.createElement("span", null, "Subtotal"),
                    React.createElement("span", null, originalTotalPrice > (cartData || {}).total_price ? (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "sidecart-footer__subtotal--original" }, formatPrice(originalTotalPrice)),
                        React.createElement("span", { className: "sidecart-footer__subtotal--total" }, formatPrice((cartData || {}).total_price))))
                        :
                            (React.createElement("span", null, formatPrice((cartData || {}).total_price))))),
                React.createElement("button", { className: "button sidecart-submit", onClick: goToCheckout, disabled: loadingSamples || cartItemsLoading }, (loadingSamples || cartItemsLoading) ? (React.createElement(Icons.Loading, null)) : (itemCount == 0
                    ? (React.createElement("span", null, "Continue Shopping")) : (React.createElement("span", null, "Proceed to Checkout")))),
                React.createElement("span", { className: "sidecart-footer__info" }, "Tax and promo codes calculated at checkout")))));
};
export default SideCart;
